import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Store} from '@ngrx/store';

import {AuthService} from './auth.service';
import * as fromApp from '../store/app.reducers';

@Injectable()
export class AnonymousGuard implements CanActivate {
  
  constructor(
    private store: Store<fromApp.AppState>,
    private authService: AuthService,
    private router: Router
  ) {}
  
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.isAnonymous()
      .pipe(
        map(
          (status: boolean) => {
            if (!status) {
              this.router.navigate(['/']);
            }
            return status;
          }
        )
      );
  }
  
}